<!--
//================================================================================
// ID:BC007
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC007
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/10 | 富士通株式会社         | 新規作成
// 01.01.00 | 2022/10/28 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.02.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.03.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.04.00 | 2025/02/03 | 富士通Japan株式会社    | 令和6年度改修対応（2次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message/>
		<div v-if="!disp.loginKbn" class="contents__information div-tyuimargin">
			<div class="div-paddingbottom">
				<font-awesome-icon icon="exclamation-triangle" />
				<label class="label-tyuijikou">注意事項</label>
			</div>
			<div class="contents__attention">
				<ul v-if="disp.bosyuKind.substring(2) == 4" class="text-lineheight">
					まだ、住宅は確保されていません。<br />住宅の仮押さえを行うには最下部の「ログインして世帯情報入力へ」を押下し、ログインしてください。<br />
					なお、ログインには、<a @click="clickRiyosyaInsert" class="contents__caution--linkStyle pointer">利用者登録</a>が必要です。<br />
					利用者登録が完了していない場合、<br />利用者登録完了後に再度住宅検索が必要になります。<br />
					※残戸数の表示にはタイムラグがあります。あらかじめご了承ください。
				</ul>
				<ul v-else class="text-lineheight">
					都営住宅募集への申込みには<a @click="clickRiyosyaInsert" class="contents__caution--linkStyle pointer">利用者登録</a>が必要です。<br />
					利用者登録が完了していない場合、申込みのときに、再度住宅検索が必要になります。
				</ul>
			</div>
		</div>
		<div v-else-if="disp.bosyuKind.substring(2) == 4" class="contents__information div-tyuimargin">
			<div class="div-paddingbottom">
				<font-awesome-icon icon="exclamation-triangle" />
				<label class="label-tyuijikou">注意事項</label>
			</div>
			<div v-if="true == disp.isZuijiMosikomi" class="contents__attention">
				<ul v-if="ZENKAKU_HYPHEN == this.disp.dispBosyukosu" class="text-lineheight">
					{{ co_getMessage('I0041') }}
				</ul>
				<ul v-else class="text-lineheight">
					{{ co_getMessage('I0042') }}
				</ul>
			</div>
			<div v-else class="contents__attention">
				<ul class="text-lineheight">
					まだ、住宅は確保されていません。住宅の仮押さえを行うには最下部の「世帯情報入力へ」を押下してください。<br />
					※残戸数の表示にはタイムラグがあります。あらかじめご了承ください。
				</ul>
			</div>
		</div>
		<div class="contents__div--PC">
			<h2 class="contents__h2 title-style">募集住宅情報</h2>
			<div  v-if="disp.loginKbn == true" class="favorite-button">
				<a v-if="'0' == disp.fgOkiniiri" class="contents__btn--favorite-mi" v-on:click="clickOkiniiriBtn()" tabindex="1">
					お気に入り未登録
				</a>
				<a v-else-if="'1' == disp.fgOkiniiri" class="contents__btn--favorite-zumi" v-on:click="clickOkiniiriBtn()" tabindex="1">
					お気に入り登録済
				</a>
			</div>
			<section>
				<table class="contents__table--stripe detail">
					<tbody>
						<tr>
							<th class="contents__input--title">
								<a :href="disp.nyukyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">入居人数</a>
							</th>
							<td colspan="3" class="contents__input--label">{{ disp.nyukyoSu }}</td>
						</tr>
						<tr>
							<th class="contents__input--title">申込地区番号</th>
							<td v-if="disp.listHideKbn == 1 || disp.listHideKbn == 2 || disp.listHideKbn == 3" class="contents__input--label">{{ disp.noMouchiku }}</td>
							<td v-else colspan="3" class="contents__input--label">{{ disp.noMouchiku }}</td>
							<th class="contents__input--title" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 2 || disp.listHideKbn == 3">
								<a :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a>
							</th>
							<td v-if="disp.listHideKbn == 1 || disp.listHideKbn == 2 || disp.listHideKbn == 3" class="contents__input--label">{{ disp.kbYugu }}</td>
						</tr>
						<tr>
							<th class="contents__input--title"><a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a></th>
							<td colspan="3" class="contents__input--label">{{ disp.jyutakuName }}<br /></td>
						</tr>
						<tr>
							<th class="contents__input--title">
								<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a>
							</th>
							<td colspan="3" class="contents__input--label">{{ disp.kusicyo }}
								<div v-if="disp.mapLink != ''">
									<a class="contents__btn--map" tabindex="2">
										<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon-size" />
										<span class="margin-map_btn" @click="moveMapSite()">地図等の詳細情報へ</span>
									</a><br/>
									<label class="contents__caution">※外部サイトへ遷移します</label>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">
								<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
							</th>
							<td colspan="3" class="contents__input--label">{{ disp.trans }}</td>
						</tr>
						<tr v-if="disp.bosyuKind.substring(2) == 4">
							<th class="contents__input--title">
								<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">残戸数</a>
							</th>
							<td v-if="isOkiniiriSearch == true" colspan="3" class="contents__input--label">{{ disp.dispBosyukosu }}</td>
							<td v-else colspan="3" class="contents__input--label">{{ disp.zanKosu }}</td>
						</tr>
						<tr v-else-if="disp.isAkijyuko">
							<th class="contents__input--title">
								<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">募集戸数</a>
							</th>
							<td class="contents__input--label">{{ disp.nuBosyukosu }}</td>
							<th class="contents__input--title">空き住戸数</th>
							<td class="contents__input--label">
								<label v-if="disp.nuAkijyukosu != null && disp.nuAkijyukosu != ''">{{ disp.nuAkijyukosu }}</label>
								<label v-else>{{ disp.zenkakuHyphen }}</label>
							</td>
						</tr>
						<tr v-else>
							<th class="contents__input--title">
								<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">募集戸数</a>
							</th>
							<td colspan="3" class="contents__input--label">{{ disp.nuBosyukosu }}</td>
						</tr>
						<tr>
							<th class="contents__input--title">間取り</th>
							<td class="contents__input--label contents__kaigyo--css">{{ disp.madori }}</td>
							<th class="contents__input--title">専用面積(m&sup2;)</th>
							<td class="contents__input--label">{{ disp.senyoArea }}</td>
						</tr>
						<tr>
							<th class="contents__input--title"><a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a></th>
							<td class="contents__input--label">{{ disp.ymkensetu }}</td>
							<th class="contents__input--title">
								<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a>
							</th>
							<td class="contents__input--label">{{ disp.elevatorUmu }}</td>
						</tr>
						<tr v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
							<th class="contents__input--title"><a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a></th>
							<td colspan="3" class="contents__input--label">
								{{ disp.jikotaisyo }}
							</td>
						</tr>
						<tr>
							<th class="contents__input--title"><a :href="disp.shiyoryoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">使用料(円)</a></th>
							<td colspan="3" class="contents__input--label">{{ disp.moSiyoryo }}</td>
						</tr>
						<tr>
							<th class="contents__input--title"><a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a></th>
							<td colspan="3" class="contents__input--label">{{ disp.siyouEtc }}</td>
						</tr>
						<tr v-if="disp.listHideKbn == 2 || disp.listHideKbn == 4">
							<th class="contents__input--title"><a :href="disp.bairituLink" target="_blank" rel="noopener noreferrer" tabindex="-1">参考倍率</a></th>
							<td colspan="3" class="contents__input--label">
								<label v-if="disp.nuBairitu != null && disp.nuBairitu != ''">{{ disp.nuBairitu }}</label>
								<label v-else>{{ disp.zenkakuHyphen }}</label>
							</td>
						</tr>
						<tr v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
							<th class="contents__input--title"><a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a></th>
							<td colspan="3" class="contents__input--label">
								{{ disp.jikonaiyo }}
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<div align="center">
					<p id="pc_text" class="contents__input--label">
						<label>
							<span v-if="disp.isZuijiMosikomi == true" ></span>
							<span v-else>申込みには世帯情報の登録が必要です。この住宅に申込む場合は「{{disp.bc008BtnName}}」ボタンをクリックしてください。<br/></span>
							住宅を選びなおす場合は下の「戻る」ボタンをクリックしてください。
						</label>
					</p>
				</div>
				<div v-if="true == disp.isZuijiMosikomi" class="contents__div--center">
					<input
						type="button"
						value="戻る"
						@click="goBackBtn"
						class="contents__btn--cancel cancel_btn"
						tabindex="3"
					/>
				</div>
				<div v-else-if="true == disp.loginKbn" class="contents__div--center">
					<input
						type="button"
						value="世帯情報入力へ"
						@click="clickInsertBtn"
						class="contents__btn--confirm detail_btn"
						ref="confirmBtn"
						tabindex="3"
					/>
					<input
						type="button"
						value="戻る"
						@click="goBackBtn"
						class="contents__btn--cancel cancel_btn"
						tabindex="4"
					/>
				</div>
				<div v-else class="contents__div--center">
					<input
						type="button"
						value="ログインして世帯情報入力へ"
						@click="clickInsertBtn"
						class="contents__btn--confirm detail_btn"
						ref="confirmBtn"
						tabindex="3"
					/>
					<input
						type="button"
						value="戻る"
						@click="goBackBtn"
						class="contents__btn--cancel cancel_btn"
						tabindex="4"
					/>
				</div>
			</section>
		</div>
		<div class="contents__div--MOBILE">
			<h2 class="contents__h2 title-style">募集住宅情報</h2>
			<div  v-if="disp.loginKbn == true" class="favorite-button">
				<a v-if="disp.fgOkiniiri == '0'" class="contents__btn--favorite-mi" v-on:click="clickOkiniiriBtn()" tabindex="1">
					お気に入り未登録
				</a>
				<a v-else-if="disp.fgOkiniiri == '1'" class="contents__btn--favorite-zumi" v-on:click="clickOkiniiriBtn()" tabindex="1">
					お気に入り登録済
				</a>
			</div>
			<section>
				<table class="contents__table--stripe">
					<tbody>
						<tr class="contents__input--tr">
							<td class="contents__kaigyo--css">
								<label class="contents__title"><a :href="disp.nyukyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">入居人数</a></label><label class="contents__text">:{{ disp.nyukyoSu }}</label><br/>
								<label class="contents__title" v-if="disp.bosyuKind.substring(2) == 4">
									<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">残戸数</a>
								</label>
								<label class="contents__text" v-if="disp.bosyuKind.substring(2) == 4 && isOkiniiriSearch == true">:{{ disp.dispBosyukosu }}</label>
								<label class="contents__text" v-if="disp.bosyuKind.substring(2) == 4 && isOkiniiriSearch == false">:{{ disp.zanKosu }}</label>
								<label class="contents__title" v-if="disp.bosyuKind.substring(2) != 4">
									<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">募集戸数</a>
								</label>
								<label class="contents__text" v-if="disp.bosyuKind.substring(2) != 4">:{{ disp.nuBosyukosu }}</label><br/>
								<span v-if="disp.isAkijyuko">
									<label class="contents__title">空き住戸数</label>
									<label class="contents__text">
										<span v-if="disp.nuAkijyukosu != null && disp.nuAkijyukosu != ''">:{{ disp.nuAkijyukosu }}</span>
										<span v-else>:{{ disp.zenkakuHyphen }}</span>
									</label><br/>
								</span>								
								<label class="contents__title">申込地区番号</label><label class="contents__text">:{{ disp.noMouchiku }}</label><span v-if="disp.listHideKbn == 1 || disp.listHideKbn == 2 || disp.listHideKbn == 3"><br/></span>
								<label class="contents__title" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 2 || disp.listHideKbn == 3"><a :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a></label><label class="contents__text" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 2 || disp.listHideKbn == 3">:{{ disp.kbYugu }}</label><br/>
								<label class="contents__title"><a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a></label><label class="contents__text">:{{ disp.jyutakuName }}</label><br/>
								<label class="contents__title"><a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a></label><label class="contents__text">:{{ disp.kusicyo }}</label><br/>
								<div v-if="disp.mapLink != ''">
									<a class="contents__btn--map" tabindex="2">
										<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon-size" />
										<span class="margin-map_btn" @click="moveMapSite()">地図等の詳細情報へ</span>
									</a><br/>
									<label class="contents__caution">※外部サイトへ遷移します</label>
								</div>
								<label class="contents__title"><a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a></label><label class="contents__text">:{{ disp.trans }}</label><br/>
								<label class="contents__title">間取り</label><label class="contents__text">:{{ disp.madori }}</label><br/>
								<label class="contents__title">専用面積(m&sup2;)</label><label class="contents__text">:{{ disp.senyoArea }}</label><br/>
								<label class="contents__title"><a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a></label><label class="contents__text">:{{ disp.ymkensetu }}</label><br/>
								<label class="contents__title"><a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a></label><label class="contents__text">:{{ disp.elevatorUmu }}</label><br/>
								<label class="contents__title" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6"><a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a></label><label class="contents__text" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">:{{ disp.jikotaisyo }}<br/></label>
								<label class="contents__title"><a :href="disp.shiyoryoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">使用料(円)</a></label><label class="contents__text">:{{ disp.moSiyoryo }}</label><br/>
								<label class="contents__title"><a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a></label><label class="contents__text">:{{ disp.siyouEtc }}</label><br/>
								<label class="contents__title" v-if="disp.listHideKbn == 2 || disp.listHideKbn == 4"><a :href="disp.bairituLink" target="_blank" rel="noopener noreferrer" tabindex="-1">参考倍率</a></label><label class="contents__text" v-if="disp.listHideKbn == 2 || disp.listHideKbn == 4"><span v-if="disp.nuBairitu != null && disp.nuBairitu != ''">:{{ disp.nuBairitu }}</span><span v-else>:{{ disp.zenkakuHyphen }}</span></label>
								<label class="contents__title" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6"><a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a></label><label class="contents__text" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">:{{ disp.jikonaiyo }}</label>
							</td>
						</tr>
					</tbody>
				</table>
				<div id="mobile_text">
					<label>
						<span v-if="disp.isZuijiMosikomi == true" ></span>
						<span v-else>申込みには世帯情報の登録が必要です。この住宅に申込む場合は「{{disp.bc008BtnName}}」ボタンをクリックしてください。<br/></span>
						住宅を選びなおす場合は下の「戻る」ボタンをクリックしてください。
					</label>
				</div>
				<br/>
				<div v-if="disp.isZuijiMosikomi == true" class="btn_area">
					<input type="button" value="戻る" class="contents__btn--cancel cancel_btn" @click="goBackBtn" tabindex="12" />
				</div>
				<div v-else-if="disp.loginKbn == true" class="btn_area">
					<input type="button" value="世帯情報入力へ" class="contents__btn--confirm" @click="clickInsertBtn" tabindex="11" />
					<input type="button" value="戻る" class="contents__btn--cancel cancel_btn" @click="goBackBtn" tabindex="12" />
				</div>
				<div v-else class="btn_area">
					<input type="button" value="ログインして世帯情報入力へ" class="contents__btn--confirm confirm_btn" @click="clickInsertBtn" tabindex="11" />
					<input type="button" value="戻る" class="contents__btn--cancel cancel_btn2" @click="goBackBtn" tabindex="12" />
				</div>
				<br/>
				<br/>
				<br/>
				<br/>
				<br/>
			</section>
		</div>
	</div>
</template>
<script>
import ErrorMessage from '@/components/ErrorMessage.vue';

import { co_post, co_put } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_confirmDialog, co_errorDialog, co_completedDialog } from '@/common/dialogUtility.js';
import { co_commaSeparated } from '@/common/stringUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_toTop, co_toTrans, co_clearParam} from '@/common/screenUtility.js';

import { HTTP_STATUS } from '@/const/const.js';
import { DIALOG_BUTTON_LIST_KEY, ZUIJI_JYUTAKU, ZENKAKU_HYPHEN } from '@/const/const.js';
import { PATH_BC007, PATH_BC007_SEARCH, PATH_BC007_CHECK, PATH_BC007_ITIJIHOZON,
			PATH_BC007_EDIT_OKINIIRI, PATH_BC007_EXIST_OKINIIRI } from '@/const/route.js';

import { STORE_VIEW_PROGRESS, STORE_ERROR_SETMSG, STORE_DATA_GETDATA, STORE_ERROR_CLEAR,
			STORE_USER_IS_AUTHENTICATED, STORE_DATA_ADD_DATA, STORE_VIEW_GET_PARAMS } from '@/const/store.js';

export default {
	name: "BC007",
	components: {
		'error-message': ErrorMessage,
	},
	data: function () {
		return {
			form: {
			},
			disp: {
				nyukyoSu: '',			// 入居人数
				nuBosyukosu: '',		// 募集戸数
				zanKosu: '',			// 残戸数
				nuAkijyukosu: '',		// 空き住戸数
				noMouchiku: '',			// 申込地区番号
				kbYugu: '',				// 優遇抽せんの有無
				jyutakuName: '',		// 住宅名
				kusicyo: '',			// 代表的な所在地
				trans: '',				// 主な交通機関
				madori: '',				// 間取り
				senyoArea: '',			// 専用面積
				ymkensetu: '',			// 建設年度
				elevatorUmu: '',		// エレベーター
				moSiyoryo: '',			// 使用料
				siyouEtc: '',			// 仕様等
				nuBairitu: '',			// 参考倍率
				jikotaisyo: '',			// 対象階
				jikonaiyo: '',			// 事故内容
				jyutakuKind: '',		// 住宅の種別
				nmZyutaku: '',			// 住宅の種別名称
				bosyuKind: '',			// 募集の種類
				nmBosyu: '',			// 募集の種類名称
				ymBosyu: '',			// 募集年月
				linkUrlList: [],		// 外部リンクURLリスト
				nyukyoLink: '', 		// 入居人数外部リンク
				yuguLink: '',			// 優遇抽せんの有無外部リンク
				jyutakuLink: '',		// 住宅名外部リンク
				syozaitiLink: '',		// 代表的な所在地外部リンク
				transLink: '',			// 主な交通機関外部リンク
				buildLink: '',			// 建設年度外部リンク
				elevatorLink: '',		// エレベーター外部リンク
				shiyoryoLink: '',		// 使用料外部リンク
				shiyoLink: '',			// 仕様等外部リンク
				bairituLink: '',		// 参考倍率外部リンク
				taisyokaiLink: '',		// 対象階外部リンク
				jikoLink: '',			// 事故内容外部リンク
				kosuLink: '',			// 戸数外部リンク
				zikoUmu: '',			// 住居内で病死等があった住宅の有無
				listHideKbn: 0, 		// 非表示区分(1:参考倍率、2：対象階・事故内容、3：参考倍率・対象階・事故内容、4：対象階・事故内容・優遇抽せん、5：全て)
				hanyoCode: '',			// 汎用コード
				loginKbn: false,		// ログイン済区分
				bc008BtnName: '',		// 世帯情報入力へボタン名称
				zenkakuHyphen: '',		// 全角ハイフン
				fgOkiniiri: '',			// お気に入り登録の有無
				dispBosyukosu: '',		// 戸数（お気に入り検索時の表示用）
				isZuijiMosikomi: false,	// 随時募集申込み可否フラグ（残戸数ゼロ、掲載終了時にtrueとなる）
				mapLink: '',			// 外部マップサービスのリンク先
				isAkijyuko: false,		// 空き住戸数表示フラグ（True：表示する、False：表示しない）
			},
			jyutakuInfo: [],			// 住宅情報
			bosyuKind: '',				// 募集の種類
			jyutakuKind: '',			// 住宅の種別
			zikoUmu: '',				// 事故有無
			isOkiniiriSearch: false,	// お気に入り検索フラグ（true：お気に入り検索、false：通常検索）
			ZENKAKU_HYPHEN: ZENKAKU_HYPHEN,
			co_commaSeparated: co_commaSeparated,
			co_getMessage: co_getMessage,
		}
	},
	mounted: async function () {
	},
	created: async function() {

		// ログイン済区分
		this.disp.loginKbn = this.$store.getters[STORE_USER_IS_AUTHENTICATED];

		// 全角ハイフン設定
		this.disp.zenkakuHyphen = ZENKAKU_HYPHEN;

		// 遷移元画面からのパラメータを取得
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC007');

		// 画面間パラメータを削除
		co_clearParam('BC007');

		if (typeof params != 'undefined') {
			this.jyutakuInfo = params.jyutakuInfo;
			this.bosyuKind = params.bosyuKind;
			this.jyutakuKind = params.jyutakuKind;
			this.zikoUmu = params.zikoUmu;
			this.isOkiniiriSearch = params.isOkiniiriSearch;
		}

		// 世帯情報入力画面から遷移した場合
		if (this.bosyuKind === '') {

			// 状態管理（ストア）から前回情報を取得
			let data = this.$store.getters[STORE_DATA_GETDATA]('BC007');

			if (data === null) {
				// 前回情報が存在しない場合、ログイン画面に遷移
				co_toTrans('BC001');
				return;
			}

			this.disp = data;

			if (!this.disp.loginKbn) {
				// ログイン済区分
				this.disp.loginKbn = this.$store.getters[STORE_USER_IS_AUTHENTICATED];

				// 入力値保持
				this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC007', data: this.disp });
			}

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// お気に入り登録有無取得
			let params = {
				kbBosyu: this.disp.bosyuKind.substring(0, 2),
				kbZyutaku: this.disp.jyutakuKind,
				ymBosyu: this.disp.ymBosyu,
				noMouchiku: this.disp.noMouchiku,
				fgOkiniiri: this.disp.fgOkiniiri
			};

			let self = this;
			let dataOkiniiri = await co_post(PATH_BC007_EXIST_OKINIIRI, params, function (res, handle) {

				if (res.status == HTTP_STATUS.OK) {
					return handle(res);
				} else {
					// ローディング表示終了
					self.$store.commit(STORE_VIEW_PROGRESS, false);
				}
			});

			if (dataOkiniiri != null) {
				this.disp.fgOkiniiri = dataOkiniiri.existOkiniiri;
			} else {
				this.disp.fgOkiniiri = 0;
			}

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);
		} 
		
		// 募集住宅一覧画面から遷移した場合
		else {
			let data = this.jyutakuInfo;

			// 入居人数
			this.disp.nyukyoSu = data.nyukyoSu;
			let maxStr = 7;
			if (data.nyukyoSu.length != maxStr){
				for (let i = 0; i < 2; i++){
					this.disp.nyukyoSu = this.disp.nyukyoSu + '\u3000' ;
				}
			}

			this.disp.nuBosyukosu = data.nuBosyukosu;
			this.disp.zanKosu = data.zanKosu;
			this.disp.nuAkijyukosu = data.nuAkijyukosu;
			this.disp.noMouchiku = data.noMouchiku;
			this.disp.kbYugu = data.kbYugu;
			this.disp.jyutakuName = data.jyutakuName;
			this.disp.kusicyo = data.kusicyo;
			this.disp.trans = data.trans;
			this.disp.madori = data.madori;
			this.disp.senyoArea = data.senyoArea;
			// 建設年度
			if (data.kensetuUpr == null || data.kensetuUpr == '') {
				this.disp.ymkensetu = data.kensetuLow;
			} else if (data.kensetuLow == null || data.kensetuLow == '') {
				this.disp.ymkensetu = '';
			} else {
				this.disp.ymkensetu = data.kensetuLow + '～' + data.kensetuUpr;
			}
			// 使用料
			if (data.moSiyoryoUpr == null || data.moSiyoryoLow == '') {
				this.disp.moSiyoryo = co_commaSeparated(data.moSiyoryoLow);
			} else if (data.moSiyoryoLow == null || data.moSiyoryoLow == '') {
				this.disp.moSiyoryo = co_commaSeparated(data.moSiyoryoLow);
			} else {
				this.disp.moSiyoryo = co_commaSeparated(data.moSiyoryoLow) + '～' + co_commaSeparated(data.moSiyoryoUpr);
			}
			this.disp.elevatorUmu = data.elevatorUmu;
			this.disp.siyouEtc = data.siyouEtc;
			this.disp.nuBairitu = data.nuBairitu;
			this.disp.jikotaisyo = data.jikotaisyo;
			this.disp.jikonaiyo = data.jikonaiyo;
			this.disp.ymBosyu = data.ymBosyu;
			this.disp.bosyuKind = this.bosyuKind;
			this.disp.jyutakuKind = this.jyutakuKind;
			this.disp.zikoUmu = this.zikoUmu;
			this.disp.nmBosyu = data.nmBosyu;
			this.disp.nmZyutaku = data.nmZyutaku;
			this.disp.fgOkiniiri = data.fgOkiniiri;
			this.disp.dispBosyukosu = data.dispBosyukosu;
			this.disp.mapLink = data.txMapLink == null ? '' : data.txMapLink;

			// 表示項目制御
			// 募集の種類コード
			this.disp.hanyoCode = this.disp.bosyuKind.substring(2);
			let boshuKindCode = this.disp.bosyuKind.substring(2);
			// 住宅の種別汎用コード１
			let jyutakuHanyoCode = this.disp.jyutakuKind;
			if (boshuKindCode == '1'){
				// 毎月募集の場合
				this.disp.listHideKbn = 3;
				if (this.disp.zikoUmu  == '1') {
					// 住居内で病死等があった住宅の場合
					this.disp.listHideKbn = 1;
				} else if (jyutakuHanyoCode == '24') {
					// 結婚予定者向（定期使用住宅・10年期限付 ※２人以上のみ）の場合
					this.disp.listHideKbn = 2;
				}
			} else if (boshuKindCode == '2' || boshuKindCode == '3'){
				// 定期募集の場合
				if (this.disp.zikoUmu  == '1') {
					// 住居内で病死等があった住宅の場合
					this.disp.listHideKbn = 1;
				} else {
					// 住居内で病死等があった住宅以外の場合
					if (jyutakuHanyoCode == '20') {
						// 世帯向（一般募集住宅・ポイント方式）の場合
						this.disp.listHideKbn = 4;
					} else if (jyutakuHanyoCode == '21') {
						// 世帯向（車いす使用者世帯向住宅・ポイント方式）の場合
						this.disp.listHideKbn = 5;
					} else if (jyutakuHanyoCode == '08') {
						// 単身者用車いす使用者向住宅（抽せん方式）
						this.disp.listHideKbn = 3;
					} else {
						// 「住居内で病死等があった住宅」かつ「『ポイント方式』と付く住宅」以外の場合
						this.disp.listHideKbn = 2;
					}
				}
			} else {
				// 随時募集の場合
				if (this.disp.zikoUmu  == '1') {
					// 居室内で病死等があった住宅 ※２人以上の家族向のみの場合
					this.disp.listHideKbn = 6;
				} else {
					// 世帯向（一般募集住宅） ※２人以上の家族向のみの場合
					this.disp.listHideKbn = 5;
				}
			}

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 外部リンク情報を取得する処理
			let self = this;
			let linkData = await co_post(PATH_BC007, null, function(res, handle){

				if (res.status == HTTP_STATUS.OK) {
					return handle(res);
				} else {
					// ローディング表示終了
					self.$store.commit(STORE_VIEW_PROGRESS, false);
				}
			});

			// 外部リンク情報を設定
			this.disp.linkUrlList = linkData.linkList;
			this.setLinkUrl();

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC007', data: this.disp });

		}
		// 住宅の種別が世帯向（一般募集住宅）※単身でも入居可能な住宅を含む、または
		// 若年夫婦・子育て世帯向（定期使用住宅・10年期限付）※２人以上の家族向のみ の場合
		if (this.disp.jyutakuKind == '04' || this.disp.jyutakuKind == '05') {
			this.disp.isAkijyuko = true;
		}

		if (this.disp.loginKbn) {
			this.disp.bc008BtnName = '世帯情報入力へ';
		} else {
			this.disp.bc008BtnName = 'ログインして世帯情報入力へ';
		}

		// お気に入り検索時、随時募集で残戸数ゼロまたは掲載終了の場合、
		// 世帯情報入力への遷移を不可とする。
		if (true == this.disp.loginKbn
			&& true == this.isOkiniiriSearch
			&& ('0' == this.disp.dispBosyukosu || ZENKAKU_HYPHEN == this.disp.dispBosyukosu)) {
			this.disp.isZuijiMosikomi = true;
		}

	},
	methods: {
		// 外部リンク設定処理
		setLinkUrl: function() {
			this.disp.nyukyoLink = this.disp.linkUrlList[0].nmCd
			this.disp.yuguLink = this.disp.linkUrlList[1].nmCd
			this.disp.jyutakuLink = this.disp.linkUrlList[2].nmCd
			this.disp.syozaitiLink = this.disp.linkUrlList[3].nmCd
			this.disp.transLink = this.disp.linkUrlList[4].nmCd
			this.disp.buildLink = this.disp.linkUrlList[5].nmCd
			this.disp.elevatorLink = this.disp.linkUrlList[6].nmCd
			this.disp.shiyoryoLink = this.disp.linkUrlList[7].nmCd
			this.disp.shiyoLink = this.disp.linkUrlList[8].nmCd
			this.disp.bairituLink = this.disp.linkUrlList[9].nmCd
			this.disp.taisyokaiLink = this.disp.linkUrlList[10].nmCd
			this.disp.jikoLink = this.disp.linkUrlList[11].nmCd
			this.disp.kosuLink = this.disp.linkUrlList[13].nmCd
		},

		// 世帯情報入力へボタン押下処理
		clickInsertBtn: async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// ログイン判定
			if (this.$store.getters[STORE_USER_IS_AUTHENTICATED] == true){
				// 随時募集の場合
				if (this.disp.bosyuKind.substring(0, 2) == '25') {

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 確認ダイアログ表示
					co_confirmDialog(co_getMessage("W0018"), this.doKariTouroku);
					return;

				} else {
					// 随時募集以外の場合、申込重複チェック
					let str = this.disp.bosyuKind.substring(0, 2);
					let noRenzoku = null;
					let mosikomiData = this.$store.getters[STORE_DATA_GETDATA]('BC008');
					if (mosikomiData != null) {
						noRenzoku = mosikomiData.noRenzoku;
					}
					let mosikomiInfo = {
						'bosyuKind' : str,
						'ymBosyu' : this.disp.ymBosyu,
						'noRenzoku' : noRenzoku
					};
					let data = await co_post(PATH_BC007_SEARCH, mosikomiInfo);
					// 取得件数が1件の場合
					if (!co_isEmpty(data)){

						// 募集年月の日付フォーマット変換
						let ymBosyu = this.disp.ymBosyu.substring(0, 4) + '年' + this.disp.ymBosyu.substring(4, 6) + '月';

						// エラーメッセージ：E0020を表示
						this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0020', this.disp.nmBosyu, ymBosyu));

						// ローディング表示終了
						this.$store.commit(STORE_VIEW_PROGRESS, false);

						// ページトップへ遷移
						co_toTop();

						return;
					}
					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 世帯情報入力画面へ遷移
					co_toTrans('BC008', { transKbn: '1' });
				}
			} else {
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 随時募集の場合
				if (this.disp.bosyuKind.substring(0, 2) == '25'){
					this.$store.commit(STORE_DATA_ADD_DATA, { id: ZUIJI_JYUTAKU, data: this.disp });
				}

				// ログイン画面へ遷移
				co_toTrans('BC001', { callViewId: 'BC008' });
			}
		},
		// 確認ダイアログ「はい」ボタン押下時処理
		doKariTouroku: async function (flg) {

			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// データ存在チェック
				let itijihozonData = await co_post(PATH_BC007_ITIJIHOZON);
				// データが存在する場合、エラーメッセージ表示
				// for(let i=0;i<itijihozonData.messageList.length;i++){
				// 	if(itijihozonData.messageList[i].unyoDate != ""){
				// 		this.$store.commit(STORE_ERROR_SETMSG, co_getMessage(itijihozonData.messageList[i].messageID,itijihozonData.messageList[i].unyoDate));
				// 		// ローディング表示終了
				// 		this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 		// ページトップへ遷移
				// 		co_toTop();

				// 		return;
				// 	}else{
				// 		this.$store.commit(STORE_ERROR_SETMSG, co_getMessage(itijihozonData.messageList[i].messageID));
				// 		// ローディング表示終了
				// 		this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 		// ページトップへ遷移
				// 		co_toTop();

				// 		return;
				// 	}
				// }
				// データが存在する場合、確認ダイアログを表示
				if (itijihozonData.messageList.length > 0){
					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					//エラー時の確認ダイアログ表示
					co_errorDialog(co_getMessage("I0034"), this.doErrDaialog);
					return;
				}
				// 一時保存データが存在しない
				// 共通部品（残戸数チェック、公開終了チェック、戸数確保（残戸数-1））の呼び出し
				let chechInfo = {
					'bosyuKind' : this.disp.bosyuKind.substring(0, 2),
					'kbZyutaku' : this.disp.jyutakuKind,
					'ymBosyu' : this.disp.ymBosyu,
					'noMouchiku' : this.disp.noMouchiku
				};
				let checkDate = await co_post(PATH_BC007_CHECK, chechInfo);
				// 戻り値判定
				if (checkDate.errorMsgId == 'E0100') {
					// 残戸数チェック
					// エラーメッセージ：E0100を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0100'));

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// ページトップへ遷移
					co_toTop();

					return;
				} else if (checkDate.errorMsgId == 'E0105') {
					// 公開終了チェック
					// エラーメッセージ：E0105を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0105'));
					
					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// ページトップへ遷移
					co_toTop();

					return;
				} else {
					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 完了ダイアログ表示
					co_completedDialog(co_getMessage('I0022'), this.doClose);
					return;
				}
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},
		// エラー時の確認ダイアログ「はい」ボタン押下時処理
		doErrDaialog: function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// メニュー画面へ遷移
				co_toTrans('BC002');
				return;
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},
		// 完了ダイアログ「はい」ボタン押下時処理
		doClose: function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// 随時募集の場合
				if (this.disp.bosyuKind.substring(0, 2) == '25'){
					this.$store.commit(STORE_DATA_ADD_DATA, { id: ZUIJI_JYUTAKU, data: this.disp });
				}
				// 世帯情報入力画面へ遷移
				co_toTrans('BC008', { transKbn: '1' });
				return;
			}
		},
		// 戻るボタン押下処理
		goBackBtn: function () {
			// 募集住宅一覧画面へ遷移
			co_toTrans('BC006');
		},
		// 利用者登録押下処理
		clickRiyosyaInsert: function () {
			// 利用者登録画面へ遷移
			co_toTrans('BC003');
		},
		// お気に入り登録／未登録ボタン押下処理
		clickOkiniiriBtn: async function () {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// お気に入り登録／未登録切り替え
			let params = {
							kbBosyu: this.disp.bosyuKind.substring(0, 2),
							kbZyutaku: this.disp.jyutakuKind,
							ymBosyu: this.disp.ymBosyu,
							noMouchiku: this.disp.noMouchiku,
							fgOkiniiri: this.disp.fgOkiniiri
						};

			let self = this;
			let data = await co_put(PATH_BC007_EDIT_OKINIIRI, params, function (res, handle) {

				if (res.status == HTTP_STATUS.OK) {
					return handle(res);
				} else {
					// ローディング表示終了
					self.$store.commit(STORE_VIEW_PROGRESS, false);
				}
			});

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			if (data != null ) {
				if ("0" != data.result) {
					// お気に入り登録／未登録切り替えエラー
					co_errorDialog(co_getMessage(data.errorMsgId, data.replaceItem), this.doOkiniiriErr);
					return;
				} else {
					// お気に入り登録／未登録切り替え完了
					// ボタンまたはマークの表示切り替え
					this.disp.fgOkiniiri = data.fgOkiniiri;
				}
			}
		},
		// お気に入り登録／未登録切り替えエラーダイアログ「OK」ボタン押下時処理
		doOkiniiriErr: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 地図等の詳細情報へボタン押下処理
		moveMapSite: function () {
			// 外部マップサービスのリンクへ遷移
			window.open(this.disp.mapLink, '_blank')
		},
	}
}
</script>
<style scoped>
.div-tyuimargin {
	margin-left: 2%;
	margin-right: 2%;
	margin-bottom: 2%;
}
.div-paddingbottom {
	padding-bottom: 20px;
}
.pointer {
	cursor: pointer;
}
.contents__btn--map {
	background:yellowgreen;
	color: #000000;
	border-radius: 25px !important;
	font-weight: normal;
	display: inline-block;
	width: auto;
	border: none;
	padding: 0.3em 1.1em;
	margin-top: 5px;
	position: relative;
	font-size: 16px;
	cursor: pointer;
}

.contents__btn--map:hover {
	background: green;
	color: #ffffff;
}

.margin-map_btn {
	margin-left: 8px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	#pc_text {
		display: inline-block;
		text-align: left;
		margin-top: 3px;
	}
	.detail_btn {
		margin-bottom: 2%
	}
	.cancel_btn {
		margin-left: 1%
	}
	.label-tyuijikou {
		font-size: 20px;
		margin-left: 1%;
	}
	.text-lineheight {
		line-height: 1.7em;
	}

	/* お気に入り登録解除ボタン */
	.favorite-button {
		margin-bottom: 20px;
		float: right;
	}
}
/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	#mobile_text {
		padding: 10px 6px 15px;
		line-height: 25px;
	}
	.cancel_btn {
		margin-left: 5%;
	}
	.cancel_btn2 {
		margin-left: 3%;
	}
	.contents__title {
		font-weight: bold;
		font-size: 18px;
	}
	.contents__text {
		font-size: 18px;
	}
	.contents__table--stripe th,
	.contents__table--stripe td {
		line-height: 27px !important;
		vertical-align: top;
		padding: 10px 10px 10px;
		border-bottom: 1px dashed #aaaaaa;
		position: relative;
	}
	.label-tyuijikou {
		font-size: 18px;
		margin-left: 1%;
	}
	.text-lineheight {
		line-height: 1.5em;
	}
	.btn_area {
		text-align: center;
	}
	.confirm_btn {
		padding: 0.5em 0.6em;
	}

	/* お気に入り登録解除ボタン */
	.favorite-button {
		margin-bottom: 15px;
		float: right;
	}
}
</style>
